import { render, staticRenderFns } from "./ListItemSkeleton.vue?vue&type=template&id=5915388a&scoped=true&"
import script from "./ListItemSkeleton.vue?vue&type=script&lang=js&"
export * from "./ListItemSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ListItemSkeleton.vue?vue&type=style&index=0&id=5915388a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5915388a",
  null
  
)

export default component.exports